import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../../common2/Modal';
import ModalHeader from '../../common2/Modal/ModalHeader';
import ModalContent from '../../common2/Modal/ModalContent';
import ModalFooter from '../../common2/Modal/ModalFooter';
import Button from '../../common2/Button/Button';
import RemoveIcon from '../../../icons/remove.svg';
import RichLocale from '../../common2/RichLocale';
import { useCancelClaim } from './useCancelClaim';

import './CancelClaimModal.scss';

function CancelClaimModal(props) {
  const { claim = {}, onClose, onSubmitSuccess } = props;
  const [cancelClaim, { isLoading }] = useCancelClaim(onClose, onSubmitSuccess);

  if (!claim) {
    return null;
  }

  const isDraft = claim.status === 'draft';

  const headerText = isDraft
    ? 'CLAIM_DRAFT_CANCELLATION_CONFIRMATION_HEADER'
    : 'CLAIM_CANCELLATION_CONFIRMATION_HEADER';

  const bodyText = isDraft
    ? 'CLAIM_DRAFT_CANCELLATION_CONFIRMATION_MESSAGE'
    : 'CLAIM_CANCELLATION_CONFIRMATION_MESSAGE';

  return (
    <Modal show={true} onClose={onClose}>
      <ModalHeader icon={RemoveIcon} intent="danger">
        {headerText}
      </ModalHeader>
      <ModalContent>
        <RichLocale values={{ trackingCode: claim.trackingCode }}>{bodyText}</RichLocale>
      </ModalContent>
      <ModalFooter>
        <Button intent="base" onClick={onClose}>
          Close
        </Button>
        <Button intent="danger" isLoading={isLoading} onClick={() => cancelClaim(claim)}>
          Cancel claim
        </Button>
      </ModalFooter>
    </Modal>
  );
}

CancelClaimModal.propTypes = {
  claim: PropTypes.object,
  onClose: PropTypes.func,
  onSubmitSuccess: PropTypes.func,
};

export default React.memo(CancelClaimModal);
